import NBType from '@netbase/nb-type'

/**
 * @typedef {object} AMDomainStatSchema
 * @property {string} domain
 * @property {number} lastIncrement
 * @property {number} total
 */
const AMDomainStatSchema = NBType.object().shape('AMDomainStatSchema', {
  /* @prop */
  domain: NBType.string(),
  /* @prop */
  lastIncrement: NBType.number(),
  /* @prop */
  total: NBType.number()
  /* END */
})
export default AMDomainStatSchema
// RESERVE BELOW
